import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Header,
  Segment,
  Table,
  Label,
  Loader,
  Icon,
} from 'semantic-ui-react';
import { Helmet } from '@plone/volto/helpers';
import { getApiPath, fetchApi } from '../../api';

export default function ReviewSchedule() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchApi(`${getApiPath()}/@qms/reviews`)
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Container style={{ paddingTop: '3em' }}>
        <Loader active inline="centered" content="Loading reviews..." />
      </Container>
    );
  }
  if (error) {
    return (
      <Container style={{ paddingTop: '2em' }}>
        <Segment color="red">Error: {error}</Segment>
      </Container>
    );
  }

  return (
    <Container style={{ paddingTop: '2em', paddingBottom: '3em' }}>
      <Helmet title="Review Schedule" />
      <Link to="/qms">&larr; QMS Dashboard</Link>

      <div className="polyglot-page-header">
        <h1>Review Schedule</h1>
      </div>

      {/* Overdue */}
      <Header as="h3" color="red">
        <Icon name="warning sign" /> Overdue ({(data.overdue || []).length})
      </Header>
      {data.overdue && data.overdue.length > 0 ? (
        <Table compact celled color="red">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Document</Table.HeaderCell>
              <Table.HeaderCell>Title</Table.HeaderCell>
              <Table.HeaderCell>Version</Table.HeaderCell>
              <Table.HeaderCell>Review Due</Table.HeaderCell>
              <Table.HeaderCell>Days Overdue</Table.HeaderCell>
              <Table.HeaderCell>Owner</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.overdue.map((r) => (
              <Table.Row key={r.document_id} negative>
                <Table.Cell>
                  <Link to={`/qms/register/${encodeURIComponent(r.document_id)}`}>
                    {r.document_id}
                  </Link>
                </Table.Cell>
                <Table.Cell>{r.title}</Table.Cell>
                <Table.Cell>{r.version}</Table.Cell>
                <Table.Cell>{r.next_review_date}</Table.Cell>
                <Table.Cell>
                  <Label color="red">{r.days_overdue}</Label>
                </Table.Cell>
                <Table.Cell>{r.owner}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      ) : (
        <Segment secondary>No overdue reviews.</Segment>
      )}

      {/* Upcoming */}
      <Header as="h3" style={{ marginTop: '2em' }}>
        Upcoming Reviews ({(data.upcoming || []).length})
      </Header>
      {data.upcoming && data.upcoming.length > 0 ? (
        <Table compact celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Document</Table.HeaderCell>
              <Table.HeaderCell>Title</Table.HeaderCell>
              <Table.HeaderCell>Version</Table.HeaderCell>
              <Table.HeaderCell>Review Due</Table.HeaderCell>
              <Table.HeaderCell>Days Until</Table.HeaderCell>
              <Table.HeaderCell>Owner</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.upcoming.map((r) => (
              <Table.Row key={r.document_id}>
                <Table.Cell>
                  <Link to={`/qms/register/${encodeURIComponent(r.document_id)}`}>
                    {r.document_id}
                  </Link>
                </Table.Cell>
                <Table.Cell>{r.title}</Table.Cell>
                <Table.Cell>{r.version}</Table.Cell>
                <Table.Cell>{r.next_review_date}</Table.Cell>
                <Table.Cell>
                  <Label
                    color={r.days_until <= 30 ? 'orange' : 'green'}
                  >
                    {r.days_until}
                  </Label>
                </Table.Cell>
                <Table.Cell>{r.owner}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      ) : (
        <Segment secondary>
          No upcoming reviews scheduled. Set review dates on effective documents.
        </Segment>
      )}
    </Container>
  );
}
